/* eslint-disable max-lines */
export const SENDER_DETAILS = "Sender's Details";
export const MOBILE_SENDER_DETAILS = "Edit Sender’s Details";
export const ORDER_RELATED_COMMUNICATION_TEXT = "Order related communication will also be sent to the sender.";
export const NAME_TITLE = "Title";
export const THIS_IS_REQUIRED = "This is required";
export const SAME_AS_RECIPIENTS_CITY = "Same as recipient’s city";
export const ORDER_RELATED_COMMUNICATION = "Order related communications will be sent to these details.";
export const EDIT_DETAILS = "Edit Details";
export const SENDER_INPUT = { placeholder: "Name", errorMessage: "Please enter sender name" };
export const LOCATION_INPUT = { placeholder: "Enter city", errorMessage: "Please enter sender location" };
export const DA_PAGE_ARGS = {
  senderName: "senderName",
  primaryContactNumber: "primaryContactNumber",
  senderLocation: "senderLocation",
};
export const DA_SENDER_DETAILS_INPUT = {
  senderName: "Sender's Name*",
  primaryContactNumber: "Sender's Mobile Number*",
  email: "Email*",
  city: "City*",
};
export const SAVE = "Save";
export const INDIA_COUNTRY_CODE = "91";
export const SENDER_DETAILS_UPDATED = "Updated successfully";
export const SENDER_MOBILE_OTP = {
  verify: "Verify",
  verified: "Verified",
  verifyError: "Please verify your mobile number to proceed",
  sendOtpError: "Error in sending OTP",
  verifyOtpError: "Error in verifying OTP",
  otpSentOn: "OTP sent to your mobile",
  otpSentToast: "OTP sent to mobile number",
  validFor: "Valid for 2 mins",
  resendOtp: "Resend OTP",
  confirmOtp: "Confirm OTP",
  change: "Change",
};
export const TERMS_N_CONDITIONS = "Default";
export const PRIVACY = "Privacy";
export const DISCLAIMER = "Disclaimers, Limitations and Exclusions of Liability";
export const DONATION_HEADING = "About CRY (Child Rights and You)";
export const DONATION_DESCRIPTION =
  "Started in 1979, CRY - Child Rights and You, is the most trusted NGO in india. It has been working towards creating happier and healthier childhoods for over 4 decades Child Rights and You, is the most trusted NGO in India";
/**
 * function to return discount address text
 * @returns {string}
 */
export const SAVING = (amountSaved) => {
  return `You are saving ₹${amountSaved} on this order`;
};
export const EMAIL_NOT_EDITABLE = "Email is not editable";
export const ADD_ADDRESS_LABEL = "Add Delivery Address";
export const EDIT_ADDRESS_LABEL = "Edit Delivery Address";
export const SELECT_DELIVERY_ADDRESS = "Select delivery address";
export const DOORBELL_HINT_TEXT = "Write the name tag as mentioned on doorbell of the building.";
export const RECEIVERS_CONTACT_INPUT = {
  RECEIVERS_NAME: "Recipient name*",
  RECEIVERS_MOBILE: "Recipient Mobile Number*",
  RECEIVERS_EMAIL: "Email id*",
  RECEIVERS_EMAIL_OPTIONAL: "Email id (optional)",
  RECEIVERS_ALT_MOBILE: "Alternate mobile number (optional)",
};
export const RECEIVERS_ADDRESS_INPUT = {
  RECEIVERS_FLAT: "Flat/House no, Floor, Tower, Block, Plot*",
  RECEIVERS_AREA: "Apartment, Street, Locality*",
  RECEIVERS_LANDMARK: "Landmark (optional)",
  RECEIVERS_PIN_CODE: "Pincode*",
  RECEIVERS_CITY: "City",
  SPC_RECEIVERS_APARTMENT_FLAT: "Apartment, Flat, Building, Company name*",
  SPC_RECEIVERS_HOUSE_NO: "House no.",
  SPC_RECEIVERS_DOORBELL_NO: "Doorbell name*",
};
export const TYPE_ADDRESS_LABEL = "Type Of Address";
export const RECEIVER_NAME = "Recipient’s name";
export const SAVE_DELIVER = "Save & Deliver Here";
export const SAVE_CONTINUE = "Save & Continue";
export const CONFIRM_TIME_SLOT_CTA = "Confirm time-slot";
export const DELIVERY_HAS_COMBINED = "deliveryHasCombined";
/**
 * Returns split-cart delivery progress label for shipping drawer header.
 * When partial out-of-stock, pass in-stock-only currentIndex and totalCount.
 *
 * @param {number} currentIndex - Zero-based index among in-stock cart items
 * @param {number} totalCount - Total in-stock cart items
 * @returns {string}
 */
export const getSplitCartDeliveryProgressLabel = (currentIndex, totalCount) => {
  if (!totalCount) {
    return "";
  }

  return `•  Delivery ${currentIndex + 1} of ${totalCount}`;
};

/**
 * Progress label for split-cart wizard using the item's position in the full in-stock list,
 * while the wizard only walks items that still need a time slot.
 *
 * @param {Object} activeOrder
 * @param {Array} serviceableOrderList
 * @returns {string}
 */
export const getSplitCartDeliveryProgressLabelForOrder = (activeOrder, serviceableOrderList = []) => {
  if (!activeOrder || !serviceableOrderList.length) {
    return "";
  }

  const originalIndex = serviceableOrderList.findIndex(
    (order) => order?.giftItem?.cartItemIndex === activeOrder?.giftItem?.cartItemIndex,
  );

  if (originalIndex < 0) {
    return "";
  }

  return getSplitCartDeliveryProgressLabel(originalIndex, serviceableOrderList.length);
};
export const CONTINUE = "Continue";
export const INTERNATIONAl_RECEIVER = {
  STREET_NO: "Street no. and name*",
  HOUSE_NO: "Apt/suite/house no.",
  ZIPCODE: "Zipcode*",
};
export const DELETE_ADDRESS = "Delete This Address";
export const DELETE_CONFIRMATION = "Are you sure you want to delete this address?";
export const ADD_NEW_ADDRESS = "Add New Address";
export const ADD_ADDRESS_MAP = {
  SEARCH_PLACEHOLDER: "Search society, apartment, locality",
  USE_CURRENT_LOCATION: "Use current location",
  DELIVERY_ADDRESS: "Delivery Address",
  ADDRESS_DETAILS: "Address details*",
  ADDRESS_DETAILS_HINT: [
    {
      text: "House No. 24, Block a, Rajouri Garden",
      color: "#757575",
      infoIcon: "false",
    },
    {
      text: "Flat 502, Tower 7, Palm Heights Society",
      color: "#757575",
      infoIcon: "false",
    },
  ],
  CONTACT_DETAILS: "Contact Details*",
  SAVE_ADDRESS: "Save Address",
  UPDATE_ADDRESS: "Update Address",
  PIN_TOOLTIP: "Move pin to near by delivery location",
  MAP_PIN_ICON: "/icons/web/mappin.svg",
  ADD: "Add",
  SEARCH_INPUT_ID: "add-address-map-search",
  // Desktop: the locality field's slot the place search renders into after "Change".
  LOCALITY_SEARCH_SLOT_ID: "add-address-locality-search-slot",
  SOCIETY_APARTMENT_LOCALITY: "Society/ Apartment/ Locality*",
  SUGGESTED_PINCODE: "Suggested Pincode:",
  USE_PINCODE: "Use Pincode",
  USE: "Use",
  TYPE_OF_ADDRESS: "Type of Address",
  CHECKING: "Checking",
  INVALID_PINCODE: "Enter a valid 6-digit PIN",
  LOCATION_BLOCKED: {
    TITLE: "Location access is blocked",
    MESSAGE: "Allow location in your browser settings, or search your location below.",
    DEVICE_OFF_TITLE: "Location is turned off",
    DEVICE_OFF_MESSAGE: "Please turn on Location on your phone, or search your area instead.",
    DEVICE_OFF_MESSAGE_DESKTOP: "Please turn on Location on your device, or search your area instead.",
    STEPS_TITLE: "How to enable location access",
    TRY_AGAIN: "Try Again",
    SEARCH_INSTEAD: "Search Location",
    STEPS: {
      IOS: [
        "Open your iPhone Settings › Privacy & Security › Location Services and turn it on.",
        "In the same list, open your browser (Safari or Chrome) and choose “While Using the App”.",
        "In Safari, tap “aA” in the address bar › Website Settings › Location › Allow.",
      ],
      ANDROID: [
        "Tap the icon next to fnp.com in the address bar.",
        "Open Permissions (or Site settings) › Location and choose Allow.",
        "Make sure Location is turned on in your phone's quick settings.",
      ],
      SAFARI: ["Open Safari › Settings › Websites › Location.", "Set fnp.com to Allow."],
      FIREFOX: [
        "Click the icon to the left of the address bar.",
        "Remove the “Blocked” setting next to Access your location.",
      ],
      DESKTOP: [
        "Click the icon to the left of fnp.com in the address bar.",
        "Turn on Location (or open Site settings › Location › Allow).",
      ],
    },
  },
  REQUIRED_ERRORS: {
    address2: "Please add society, apartment or locality",
    address1: "Please enter complete address",
    postalCode: "Please enter pincode",
    toName: "Please enter recipient name",
    mobileNumber: "Please enter recipient mobile number",
    email: "Please enter recipient email ID",
  },
};
export const SAVED_ADDRESS = "Saved Addresses";
export const ADD_ADDRESS_TOAST = "Address saved successfully!";
export const UPDATE_ADDRESS_TOAST = "Address updated successfully!";
export const ADDRESS_ADDED_SUCCESSFULLY = "Address added successfully";
export const TIME_SLOT_SELECTED_SUCCESSFULLY = "Time-slot selected successfully";
export const CHANGE_ADDRESS = "Change Address";
export const CHANGE = "Change";
export const ADD_ADDRESS = "Add Address";
export const SELECT_ADDRESS = "Select Address";
export const PLEASE_ADD_ADDRESS_FOR_TIME_SLOT = "Please add address to choose preferred time slot.";
export const FORM_ERROR_MESSAGE = "Please save your address to proceed.";
export const NO_ADDRESS = "No saved addresses yet";
export const NO_ADDRESS_TEXT = "Add your delivery address for a faster checkout experience.";
export const SERVICEABILITY_LOCATION_ERROR =
  "Items are not available at this location. Choose another delivery location to continue.";
export const SERVICEABILITY_LOCATION_WARNING =
  "A different location may change item availability and delivery schedule.";
export const SERVICEABILITY_WARNING_COLOR = "#1069FE";
export const GIFT_OFFICE_HOURS = "Gift will be delivered in general office hours.";
export const FNP_WITH_COUPON_HEADING = "This coupon code cannot be used with fnpCash";
export const CONTINUE_WITH_FNP_CASH = "Continue with fnpCash";
export const CONTINUE_WITH_COUPON_CODE = "Continue with Coupon Code";
export const LOGIN_SIGNUP = "Login/Signup";
export const CHOOSE_TIME_SLOT = "Choose Time-slot";
export const CHOOSE_TIME_SLOT_DRAWER_TITLE = "Choose Time-slot";
export const CHOOSE_COMBINED_TIME_SLOT_DRAWER_TITLE = "Choose Combined Time-slot";
export const CHECKOUT_DELIVERY_LABEL = "Delivery";
export const EDIT = "Edit";
export const WANT_ALL_ITEMS_SINGLE_DELIVERY = "Want your gifts delivered together? Make it one special surprise!";
export const COMBINE_SAVE_SHIPPING_DESCRIPTION = "Get your gifts delivered together. You also save ";
export const GET_GIFT_ITEM_IN_SAME_SLOT = "Get gift items delivered in same time slots.";
export const COMBINE_DELIVERIES = "Combine deliveries";
export const WOULD_RESET_DELIVERY = "Send items in separate deliveries?";
export const SPLIT_PREFERENCE_WILL_REMOVED = "Get your gifts delivered in different time-slots";
export const YES_COMBINE = "Combine";
export const COMBINE_DRAWER_TRANSITION_MS = 500; // Wait for combine drawer open animation (~0.5s) before closing the previous drawer.
export const RESET_DELIVERIES = "Split Deliveries";
export const WANT_TO_SPLIT = "Send items in separate deliveries?";
export const SPLIT_DELIVERIES_CONFIRM_DESCRIPTION =
  "Gifts will be delivered in separate deliveries based on time slot. Additional delivery charges may apply.";
export const SPLIT_DELIVERIES_CONFIRM_YES = "Yes";
export const SPLIT_DELIVERIES_CONFIRM_CANCEL = "Cancel";
export const RESET_DELIVERY_COOKIE = "isResetDelivery";
export const DELIVERY_DATE_UPDATED_NUDGE_PREFIX = "Delivery date has been updated to";
export const DELIVERY_DATE_NUDGE_HIDE_MS = 5000;
export const DELIVERY_DATE_NUDGE_ADDRESS_SELECT_MS = 5000;
export const DELIVERY_DATE_NUDGE_ANIMATION_MS = 300;
export const COMBINED_SAVINGS_ENTER_MS = 500;
export const COMBINED_CELEBRATION_DISPLAY_MS = 3500;
export const COMBINED_CELEBRATION_EXIT_MS = 700;
export const COMBINED_CELEBRATION_TITLE = "Wohooo!";
export const COMBINED_CELEBRATION_DESKTOP_DESCRIPTION_PREFIX = "With combine delivery, you saved";
export const COMBINED_GENERAL_TEXT = "Your items will arrive together";
export const COMBINED_CELEBRATION_GOT_IT = "Got It!";
export const CURRENTLY_OUT_OF_STOCK = "Out of Stock";
export const VIEW_AVAILABLE = "View Available";
export const REMOVED_AFTER_CHECKOUT = "This item(s) will be removed from your cart after checkout.";
export const CART_ITEMS_NOT_AVAILABLE = "Select items have gone out of stock!";
export const SPECIAL_SHIPPING_INSTRUCTIONS_LABEL = "Special (Shipping) Instructions";
export const SPECIAL_SHIPPING_INSTRUCTIONS_MAX_LENGTH = 250;
export const COMBO_QUANTITY_CONFIRM_TITLE = "Apply changes to all items?";
export const COMBO_QUANTITY_CONFIRM_DESCRIPTION = "Do you want to increase quantity for all items in the combo?";
export const COMBO_QUANTITY_DECREASE_CONFIRM_TITLE = "Apply changes to all items?";
export const COMBO_QUANTITY_DECREASE_CONFIRM_DESCRIPTION = "Do you want to decrease quantity of all items in the combo";
export const COMBO_QUANTITY_CONFIRM_NO = "No";
export const COMBO_QUANTITY_CONFIRM_YES = "Yes";
export const CART_EXPIRY_DELIVERY_PREFIX = "Delivery";
export const CART_EXPIRY_EXPIRES_IN = "Expires in";
export const CART_EXPIRY_HURRY_UP = "Hurry up!";
export const CART_EXPIRY_PRODUCT_EXPIRED = "Your delivery time-slot is no longer available";
export const CART_EXPIRY_DATE_EXPIRED = "Your selected delivery date is no longer available";
export const CART_EXPIRY_REMOVE_LABEL = "The next available slot is ready to choose.";
export const CART_EXPIRY_DATE_EXPIRED_DESCRIPTION = "The next available date is ready to choose.";
export const CART_EXPIRY_CHANGE_DATE_TIME = "Choose Time-slot";
export const CART_EXPIRY_CHANGE_DATE = "Choose delivery date";
export const CART_EXPIRY_TIME_SLOT_VALID_FOR = "Time-slot valid for";
export const CART_ITEM_TIME_SLOT_EXPIRED_SUFFIX = "delivery time-slot no longer available. Choose another time-slot.";
export const CART_ITEM_TIME_SLOT_EXPIRED_FALLBACK =
  "Selected delivery time-slot has expired. Please choose another time-slot.";
export const CART_ITEM_DATE_EXPIRED_PREFIX = "Delivery on";
export const CART_ITEM_DATE_EXPIRED_SUFFIX = "is no longer available. Choose a different delivery date.";
export const CART_ITEM_DATE_EXPIRED_FALLBACK =
  "Delivery on the selected date is no more available. Choose a different delivery date.";
export const CART_EXPIRY_DATE_TIME_INFO = "date & time slot";
export const YOUR_COUPON_CODE = "Your coupon code";
export const IS_NOT_VALID_FOR_THIS_ORDER = "is not valid for this order";
export const CART_EXPIRY_MOBILE_MINUTE = "m";
export const CART_EXPIRY_MOBILE_SECOND = "s";
export const CART_EXPIRY_DESKTOP_MINUTE = "min";
export const CART_EXPIRY_DESKTOP_SECOND = "sec";
export const MOBILE_CHECKOUT_FOOTER_CTA_CLASSES = "flex w-full flex-shrink-0 gap-12 border-t-1 bg-white-900 p-16 pt-12";
export const MOBILE_CHECKOUT_SCROLL_AREA_CLASSES =
  "min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain scrollbar-hide";

/**
 * @function createAddressWithComma
 * @description Adds a comma to the address value if it exists
 * @param {string} value - The address value to process
 * @param {string} [comma=", "] - The separator to add after the value
 * @returns {string} Formatted address string with comma if value exists
 */
export const createAddressWithComma = (value, comma = ", ") => {
  if (value && value !== "_NA_") {
    return `${value}${comma} `;
  } else {
    return "";
  }
};
/**
 * function to return phone validation message
 * @returns {string}
 */
export const PHONE_ERROR = (number) => {
  return `Please enter valid ${number} digit mobile no.`;
};
/**
 * @function getMobileNumberWithoutCountryCode
 * to strip the country code and the spaces prefixed on a saved mobile number, so that the
 * country code is neither repeated on the screen nor sent twice to the OTP apis.
 * @param {string} mobileNumber - mobile number which can be prefixed with the country code.
 * @param {string} countryCode - country code of the mobile number.
 * @returns {string} mobile number holding only the digits of the number.
 */
export const getMobileNumberWithoutCountryCode = (mobileNumber, countryCode) => {
  const number = `${mobileNumber || ""}`.replace(/\s/g, "");
  const code = `${countryCode || ""}`.replace(/\D/g, "");
  const numberWithoutCode = code && number.startsWith(`+${code}`) ? number.slice(code.length + 1) : number;

  return numberWithoutCode.replace(/\D/g, "");
};

/**
 * @function phoneNumberValidation
 * to check mobile number validation based upon country
 */
export const phoneNumberValidation = (value, countryCode) => {
  const errorObj = {
    isError: false,
    errorMsg: "",
  };
  if (value?.length) {
    if (countryCode === "91") {
      if (value.length === 10) {
        errorObj.isError = false;
        errorObj.errorMsg = "";
      } else {
        errorObj.isError = true;
        errorObj.errorMsg = PHONE_ERROR(10);
      }
    } else {
      if (value.length >= 7 && value.length <= 15) {
        errorObj.isError = false;
        errorObj.errorMsg = "";
      } else {
        errorObj.isError = true;
        errorObj.errorMsg = "Please Enter valid mobile no.";
      }
    }
  } else {
    errorObj.isError = true;
    errorObj.errorMsg = THIS_IS_REQUIRED;
  }
  return errorObj;
};
